export const SOCIAL_PLATFORMS_OPTIONS = {
    1: true,
    4: true,
    23: true,
    '2-1': true,
    '2-2': true,
    '2-5': true,
    '3-1': true,
    '3-5': true,
};

export const BROADCAST_PLATFORM_OPTIONS = {
    5: true,
};

export const GAME_PLATFORM_OPTIONS = (includeBroadcast, includeInVenue) => [
    includeBroadcast && 5,
    includeInVenue && 26,
].filter(Boolean)
    .reduce((acc, val) => ({ ...acc, [val]: true }), {});
